import "./whyWemust.css";

const WhyWeMust = ({ data }: { data: any }) => {
  return (
    <div className="why-wemust-container">
      <div className="header">{data?.header}</div>
      <div className="why-wemust-points">
        {data?.points &&
          data?.points?.map((point: any) => (
            <div key={point?.id} className="why-wemust-point-item">
              <img
                src={point?.icon}
                width={36}
                height={36}
                alt={point?.title}
              />
              <div>
                <div className="title">{point?.title}</div>
                <div className="description">{point?.description}</div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default WhyWeMust;
